var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('slider'),_c('div',{staticClass:"main-content col-12 px-0"},[_c('game-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }